/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GenderEnum } from './genderEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface Patient { 
    readonly id: number;
    firstName?: string;
    lastName?: string;
    email: string;
    phone?: string;
    patientId: string;
    gender: GenderEnum;
    dob?: string | null;
    organizations: Array<string>;
    crmContactId?: string;
    crmDealId?: string;
    crmLeadId?: string;
}
export namespace Patient {
}

export const Patient_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Patient_firstName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const Patient_lastName_Validators: ValidatorFn[] =
    [  Validators.maxLength(1023),];

export const Patient_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const Patient_phone_Validators: ValidatorFn[] =
    [  Validators.maxLength(63),];

export const Patient_patientId_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(7),];

export const Patient_gender_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Patient_dob_Validators: ValidatorFn[] =
    [ ];

export const Patient_organizations_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const Patient_crmContactId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const Patient_crmDealId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];

export const Patient_crmLeadId_Validators: ValidatorFn[] =
    [  Validators.maxLength(31),];


